import React, { useEffect, useState, Fragment } from 'react';
const STORAGE_KEY = 'artepronta_offer_end';
const DURATION_MS = 24 * 60 * 60 * 1000; // 24h
function getOrCreateEndTime(): number {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const t = parseInt(stored, 10);
      if (!isNaN(t) && t > Date.now()) return t;
    }
  } catch (e) {}
  const end = Date.now() + DURATION_MS;
  try {
    localStorage.setItem(STORAGE_KEY, String(end));
  } catch (e) {}
  return end;
}
function format(n: number) {
  return String(Math.max(0, n)).padStart(2, '0');
}
export function CountdownBanner() {
  const [endTime] = useState(() => getOrCreateEndTime());
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const remaining = Math.max(0, endTime - now);
  const hours = Math.floor(remaining / 3600000);
  const minutes = Math.floor(remaining % 3600000 / 60000);
  const seconds = Math.floor(remaining % 60000 / 1000);
  return null;
}